import * as s from "react";
import { useMemo as c, useRef as d, useEffect as f } from "react";
import { createPortal as l } from "react-dom";
import { AnimatedMapboxPopup as g } from "./index.es438.js";
import "./index.es439.js";
import "./index.es4.js";
import "./index.es20.js";
import "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import { usePLMapboxRefV2 as L } from "./index.es8.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const M = (t) => {
  const e = L(t.mapId), n = c(() => document.createElement("div"), []), a = d({ props: t });
  a.current.props = t;
  const o = c(() => {
    const r = { ...t }, m = new g(r).setLngLat([t.longitude, t.latitude]);
    return m.once("open", (p) => {
      var i, u;
      (u = (i = a.current.props).onOpen) == null || u.call(i, p);
    }), m;
  }, [t.latitude]);
  return f(() => {
    const r = (m) => {
      var p, i;
      (i = (p = a.current.props).onClose) == null || i.call(p, m);
    };
    return o.on("close", r), e && o.setDOMContent(n).addTo(e.getMap()), () => {
      o.off("close", r), o.isOpen() && o.remove();
    };
  }, [e, o, n]), o.isOpen() && (o.getLngLat().lng !== t.longitude || o.getLngLat().lat !== t.latitude) && o.setLngLat([t.longitude, t.latitude]), l(t.children, n);
}, Po = s.memo(M);
export {
  Po as default
};
//# sourceMappingURL=index.es204.js.map
